


















































import { Component, Vue, Prop } from "vue-property-decorator";
import Header from "@/components/header.vue";
import LeftNav from "../components/left-nav.vue";
@Component({
  components: {
    Header,
    LeftNav,
  },
})
export default class Name extends Vue {
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private get user() {
    return this.$store.state.user;
  }
  private goRoute(path: any) {
    this.$router.push(path);
  }
  mounted() {}
}
